import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import HotelDetailPopup from './hotel-detail-popup';

const statusColor = (rating: number) => {
    if (rating < 1.5) {
        return '#EE2E24';
    } else if (rating < 2.5) {
        return '#F2AF00';
    } else {
        return '#00A14E';
    }
}

interface IHotelItemProps {
    item: any
}

const HotelItem: React.FC<IHotelItemProps> = ({ item }) => {
    const { t } = useTranslation()
    return (
        <div  className="item-hotel" >
            <div className="item-wrapper">
                <Link to="/inner-page">
                    <div className="item-image">
                        <img src={item.imagePath} alt={item.title} />
                        <div className="rating" style={{ background: statusColor(item.rating) }}>{item.rating}</div>
                    </div>
                </Link>

                <div className="item-detail">
                    <Link to="/inner-page"><h4>{item.title}</h4></Link>
                    <p>{item.subTitle}</p>
                    <div className="item-hotel-bottom">
                        <div className="hotal-feacher">
                            <span className='hotel-icon hotel-wifi'></span>
                            <span className='hotel-icon hotel-breakfast'></span>
                            <span className='hotel-icon hotel-restaurant'></span>
                        </div>
                        <div className="hotal-price-book">
                            <span className='hotel-price'>$203</span>
                            <span className='hotel-book'>
                                <Link className="cta cta-small" to="/inner-page">{t('Book')}</Link>
                            </span>
                        </div>
                    </div>
                </div>
                <HotelDetailPopup
                    buttonElemnts={
                        <span className="quick-tour">
                            <img src={'/images/icons/icon-view-tour.png'} alt={'icon-view-tour'} />
                        </span>
                    }
                    hoteltitle={item.title}
                />
            </div>
        </div>
    )
};

export default HotelItem;

